/**
 * Discrete legal footer — shown on every page.
 *
 * Variants:
 *   - "inline" (default): inserted at the end of a scrolling main column.
 *   - "fixed": pinned to the bottom of the viewport — used on auth-shell
 *     screens whose centered grid layout has no natural footer slot.
 */
export default function LegalFooter({ variant = "inline", style }) {
  const isFixed = variant === "fixed";
  return (
    <div
      style={{
        ...(isFixed
          ? {
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              padding: "10px 24px",
              background: "var(--parapet-bg)",
              borderTop: "1px solid var(--parapet-grid)",
              pointerEvents: "none",
              zIndex: 5,
            }
          : {
              marginTop: 48,
              paddingTop: 16,
              borderTop: "1px solid var(--parapet-grid)",
            }),
        fontSize: 11,
        lineHeight: 1.5,
        color: "var(--parapet-text-secondary)",
        textAlign: "center",
        ...(style || {}),
      }}
      data-testid="legal-footer"
    >
      © {new Date().getFullYear()} Parapet. Parapet is a trading name of
      Linkup Ltd, a company registered in England and Wales under company
      number 17060828.
    </div>
  );
}
